/** The manual reschedule workspace's route (AB#811): App.tsx's `/appointments/availability/resolve/:overrideId`. */
export const MANUAL_RESCHEDULE_ROUTE = "/appointments/availability/resolve/:overrideId"

/** Where the manual reschedule workspace for one override lives. */
export function manualReschedulePath(overrideId: string): string {
  return `/appointments/availability/resolve/${encodeURIComponent(overrideId)}`
}
